import 'altcha';
import { forgotPassword } from './auth-api';
import { API_BASE } from '../network/api';
import { t } from '../../engine/i18n';

export function renderForgotPassword(root: HTMLElement): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <form class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift" id="forgot-form" novalidate>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">${t('auth.forgot.heading')}</h1>
        <p class="mb-6 text-sm text-text-dim">${t('auth.forgot.sub')}</p>
        <div id="forgot-error" class="mb-3.5 px-3 py-2.5 bg-error/[0.08] border border-error/40 rounded text-error text-[13px]" hidden></div>
        <div id="forgot-success" class="mb-3.5 px-3 py-2.5 bg-success/[0.08] border border-success/40 rounded text-success text-[13px]" hidden>
          ${t('auth.forgot.success')}
        </div>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">${t('auth.forgot.email')}</span>
          <input type="email" name="email" autocomplete="email" required
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <div class="mb-3.5">
          <altcha-widget challenge="${API_BASE}/auth/altcha-challenge" auto="onload" name="altcha"></altcha-widget>
        </div>
        <button type="submit" class="inline-block w-full p-3 bg-gold text-bg font-bold border-0 rounded transition-colors duration-[120ms] hover:bg-gold-bright disabled:bg-border disabled:text-text-dim disabled:cursor-not-allowed" id="forgot-btn">${t('auth.forgot.submit')}</button>
        <p class="mt-5 text-[13px] text-text-dim text-center">
          <a href="/login">${t('auth.forgot.backToSignIn')}</a>
        </p>
      </form>
    </div>
  `;

  const form = root.querySelector('#forgot-form') as HTMLFormElement;
  const errEl = root.querySelector('#forgot-error') as HTMLDivElement;
  const okEl  = root.querySelector('#forgot-success') as HTMLDivElement;
  const btn = root.querySelector('#forgot-btn') as HTMLButtonElement;

  const handler = async (e: Event) => {
    e.preventDefault();
    errEl.hidden = true;
    okEl.hidden = true;
    const fd = new FormData(form);
    const altchaPayload = fd.get('altcha') as string | null;
    if (!altchaPayload) {
      errEl.textContent = t('auth.forgot.verifyWait');
      errEl.hidden = false;
      return;
    }
    btn.disabled = true;
    btn.textContent = t('auth.forgot.submitting');
    try {
      await forgotPassword(String(fd.get('email') ?? ''), altchaPayload);
      okEl.hidden = false;
    } catch (err) {
      errEl.textContent = (err as Error).message;
      errEl.hidden = false;
    } finally {
      btn.disabled = false;
      btn.textContent = t('auth.forgot.submit');
    }
  };
  form.addEventListener('submit', handler);
  return () => form.removeEventListener('submit', handler);
}
